import React, { useEffect, useState } from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import '../assets/styles/Main.scss';
import myprofilepic from "../assets/images/myprofilepic.jpg";

function Main() {
  const [currentRole, setCurrentRole] = useState(0);
  const [displayText, setDisplayText] = useState('');

  useEffect(() => {
    document.title = "kekeli";
  }, []);

  useEffect(() => {
    const roles = [
      'Software Developer',
      'IT Specialist',
      'Data Analyst',
      'Full Stack Engineer',
      'AI/ML Enthusiast',
      'Code Architect'
    ];

    const currentRoleText = roles[currentRole];
    let charIndex = 0;
    let isDeleting = false;

    const typeWriter = () => {
      if (!isDeleting && charIndex < currentRoleText.length) {
        setDisplayText(currentRoleText.substring(0, charIndex + 1));
        charIndex++;
        setTimeout(typeWriter, 100);
      } else if (isDeleting && charIndex > 0) {
        setDisplayText(currentRoleText.substring(0, charIndex - 1));
        charIndex--;
        setTimeout(typeWriter, 50);
      } else if (!isDeleting && charIndex === currentRoleText.length) {
        setTimeout(() => {
          isDeleting = true;
          typeWriter();
        }, 2000);
      } else if (isDeleting && charIndex === 0) {
        isDeleting = false;
        setCurrentRole((prev) => (prev + 1) % roles.length);
        setTimeout(typeWriter, 500);
      }
    };

    typeWriter();
  }, [currentRole]);

  return (
    <div className="container">
      <div className="about-section">
        <div className="code-background">
          <div className="code-line">1</div>
          <div className="code-line">2</div>
          <div className="code-line">3</div>
          <div className="code-line">4</div>
          <div className="code-line">5</div>
          <div className="code-line">6</div>
          <div className="code-line">7</div>
          <div className="code-line">8</div>
          <div className="code-line">9</div>
          <div className="code-line">10</div>
        </div>

        <div className="terminal-window">
          <div className="terminal-header">
            <div className="terminal-buttons">
              <span className="red"></span>
              <span className="yellow"></span>
              <span className="green"></span>
            </div>
            <div className="terminal-title">portfolio.sh</div>
          </div>
          <div className="terminal-content">
            <div className="terminal-line">
              <span className="terminal-prompt">$</span>
              <span className="terminal-command">whoami</span>
            </div>
            <div className="terminal-output">loshar-hammond</div>
            <div className="terminal-line">
              <span className="terminal-prompt">$</span>
              <span className="terminal-command">cat skills.txt</span>
            </div>
            <div className="terminal-output">
              <span className="skill-highlight">JavaScript</span> |
              <span className="skill-highlight">TypeScript</span> |
              <span className="skill-highlight">React</span> |
              <span className="skill-highlight">Node.js</span> |
              <span className="skill-highlight">Python</span>
            </div>
          </div>
        </div>

        <div className="image-wrapper">
          <img src={myprofilepic} alt="Avatar" />
          <div className="image-glow"></div>
        </div>

        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/LosharHammond" target="_blank" rel="noreferrer" className="social-link">
              <GitHubIcon/>
              <span className="social-tooltip">GitHub</span>
            </a>
            <a href="https://linkedin.com/in/losharhammond" target="_blank" rel="noreferrer" className="social-link">
              <LinkedInIcon/>
              <span className="social-tooltip">LinkedIn</span>
            </a>
            <a href="mailto:losharhammond@gmail.com?subject=Hello&body=I%20want%20to%20contact%20you" className="social-link">
              <EmailIcon />
              <span className="social-tooltip">Email</span>
            </a>
            <a href="whatsapp://send?phone=233557297728&text=Hi%20Loshar,%20I%20want%20to%20contact%20you" target="_blank" rel="noreferrer" className="social-link">
              <WhatsAppIcon />
              <span className="social-tooltip">WhatsApp</span>
            </a>
          </div>

          <div className="name-section">
            <span className="bracket bracket-open">{"{"}</span>
            <h1 className="name">
              <span className="const-keyword">const</span>
              <span className="variable-name">name</span>
              <span className="equals">=</span>
              <span className="string-value">"Loshar Hammond"</span>
            </h1>
            <span className="bracket bracket-close">{"}"}</span>
          </div>

          <div className="role-section">
            <span className="function-keyword">function</span>
            <span className="function-name">getRole</span>
            <span className="parentheses">()</span>
            <span className="curly-open">{"{"}</span>
            <p className="role">
              <span className="return-keyword">return</span>
              <span className="string-value">"{displayText}"</span>
              <span className="cursor">|</span>
            </p>
            <p className="comment">// (changing titles)</p>
            <span className="curly-close">{"}"}</span>
          </div>

          <div className="code-stats">
            <div className="stat">
              <span className="stat-number">500+</span>
              <span className="stat-label">Commits</span>
            </div>
            <div className="stat">
              <span className="stat-number">50+</span>
              <span className="stat-label">Projects</span>
            </div>
            <div className="stat">
              <span className="stat-number">5+</span>
              <span className="stat-label">Years</span>
            </div>
          </div>

          <div className="mobile_social_icons">
            <a href="https://github.com/LosharHammond" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://linkedin.com/in/losharhammond" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;